<script setup lang="ts">
withDefaults(defineProps<{ value: string | number; label: string; tone?: 'accent' | 'fail' | 'ok' | 'neutral' }>(), { tone: 'neutral' })
</script>

<template>
  <div class="ck-stat-tile">
    <strong :class="`tone-${tone}`">{{ value }}</strong>
    <span>{{ label }}</span>
  </div>
</template>

<style scoped>
.ck-stat-tile { padding: 18px 20px; border: 1px solid var(--color-border); border-radius: var(--radius-lg); background: var(--color-surface); }
.ck-stat-tile strong { display: block; font-family: var(--font-display); font-weight: 800; font-size: 34px; line-height: 1; color: var(--color-text); }
.ck-stat-tile span { display: block; margin-top: 6px; font-size: 13px; color: var(--color-text-muted); }
.tone-accent { color: var(--ck-amber-400); }
.tone-fail { color: var(--ck-fail-500); }
.tone-ok { color: var(--ck-ok-500); }
</style>
